import { ApiClientConfigInterface, createApiClient } from '@datahub/api-client';
import { restClients } from './Clients';
import { ApiOperation, operations } from './Api';

export * from './Api';
export * from './Clients';

export const initApiClients = (clients: ApiClientConfigInterface<restClients>[]) =>
  createApiClient<restClients, ApiOperation>(clients, operations);
